<template>
  <div class="vch-my-wishlist-all-prodcuts">
    <div class="vch-grid">
      <div class="
                            vch-col-offset-md-3
                            vch-col-12
                            vch-col-md-10
                            vch-col-offset-md-1
                            vch-col-lg-10
                            vch-col-offset-lg-2
                            vch-col-xl-6
                            vch-col-offset-xl-3
                        ">
          <vch-filter-list></vch-filter-list>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from 'EventBus/';
import { setupCardImpressions } from 'Mixins/setupCardImpressions/setupCardImpressions';

export default {
  name: 'vch-my-wishlist-all-prodcuts',
  mixins: [setupCardImpressions],
  props: {
    buttonText: {
      type: String,
    },
    api: {
      type: String,
      required: true,
    },
    currentPage: {
      type: String,
      required: true,
    },
    currentPageTemplate: {
      type: String,
      required: true,
    },
    pageSize: {
      type: String,
      required: true,
    },
    keyword: {
      type: String,
      required: false,
      default: '',
    },
    totalProductCount: {
      type: String,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
    playVideoAriaLabel: {
      type: String,
      default: 'video',
    },
    infoHead: {
        type: String,
        required: true,
    },
  },
  data() {
    return {
      items: [],
      pageNbr: 1,
      label: '',
      impressions: [],
      newItems: null,
      loading: false,
      filters: [],
      busName: 'item-grid',
      isFiltersSelected: false,
      totalFilteredResults: null,
      initialProductsLoaded: true,
      infoTitle: this.infoHead,
    };
  },
  created() {
    eventBus.$on(`${this.busName}:load`, this.loadMoreProducts);
    eventBus.$on(`${this.busName}:filters`, this.onSelectFilter);
  },
  computed: {
    showLoadMoreBtn() {
      if (this.filters?.length) {
        return Number(this.totalFilteredResults) > this.items.length;
      } else {
        return (
          this.items.length + Number(this.pageSize) <
          Number(this.totalProductCount)
        );
      }
    },
    isVideos() {
      return this.pageType === 'video';
    },
    isProducts() {
      return this.pageType === 'product';
    },
    isArticles() {
      return this.pageType === 'article';
    },
    isMixedContent() {
      return this.pageType === 'mixedcontent';
    },
  },
  watch: {
    loading() {
      eventBus.$emit(`${this.busName}:loadingState`, this.loading);
    },
  },
  methods: {
    loadMoreProducts() {
      this.pageNbr = this.pageNbr + 1;
      this.isFiltersSelected = false;
      this.getData();
    },
    getRequestUrl() {
      const queryParams = new URLSearchParams();
      queryParams.set('pagenumber', this.pageNbr);
      queryParams.set('pagesize', this.pageSize);
      queryParams.set('currentpage', this.currentPage);
      queryParams.set('keyword', this.keyword);
      queryParams.set('currentpagetemplate', this.currentPageTemplate);
      if (!!this.filters && this.filters.length) {
        this.filters.forEach((filter) => {
          queryParams.set(filter.type, filter.label);
        });
      }
      return `${this.api}?${queryParams.toString()}`;
    },
    getData() {
      fetch(this.getRequestUrl())
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }
          this.newItems = null;
          if (this.isVideos) {
            this.newItems = data.Data.Videos.length;
            this.items.push(...data.Data.Videos);
          } else if (this.isArticles) {
            this.newItems = data.Data.Articles.length;
            this.items.push(...data.Data.Articles);
          } else if (this.isMixedContent) {
            this.newItems = data.Data.Content.length;
            this.items.push(...data.Data.Content);
          } else {
            if (this.isFiltersSelected) {
              this.items = [];
            }
            this.totalFilteredResults = data.TotalProductCount;
            this.newItems = data.Data.Products.length;
            this.items.push(...data.Data.Products);

            eventBus.$emit(
              `${this.busName}:total-filters-result`,
              this.totalFilteredResults
            );

            eventBus.$emit(
              `${this.busName}:update-filters`,
              data.Data.filter || []
            );
          }
          this.$nextTick(() => {
            this.setVideoAttr();
            this.loading = false;
            this.setFocus();
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    setFocus() {
      let elementsCount = this.items.length - this.newItems;
      if (!this.filters?.length && !this.isFiltersSelected) {
        elementsCount += Number(this.pageSize);
      }
      document.querySelectorAll('.vch-card__link')[elementsCount]?.focus();
    },
    setVideoAttr() {
      const videoList = document.querySelectorAll('.vch-grid li');
      if (this.isVideos) {
        videoList.forEach((video) => {
          video.setAttribute('itemprop', 'video');
          video.setAttribute('itemscope', '');
          video.setAttribute('itemtype', 'https://schema.org/VideoObject');
        });
      }
    },

    onSelectFilter(data) {
      this.pageNbr = 1;
      this.loading = true;
      this.isFiltersSelected = true;
      this.initialProductsLoaded = false;
      const obj = {};
      if (data !== null) {
        data.forEach(function (v) {
          obj[v.type] = (obj[v.type] || []).concat(v.value);
        });
        const filters = Object.keys(obj).reduce(function (s, a) {
          s.push({ type: a, label: obj[a].join() });
          return s;
        }, []);
        this.filters = filters;
      } else {
        this.filters = data;
      }
      this.getData();
    },
  },
};
</script>
<style lang="scss" src="./my-wishlist-all-products.scss"></style>
